import { useEffect }          from 'react';
import { store }              from 'index';
import { updateInfoType }     from 'types';
import { SET_CHANGE_CONTENT } from 'actions/contentActions';

const useSetChangeContent = (dataUpdateState: updateInfoType) => {

  useEffect(() => {
    if ( dataUpdateState.final ) {
      store.dispatch(SET_CHANGE_CONTENT(true));
    }
  },[dataUpdateState])

}

export default useSetChangeContent